import React from 'react';
import { IntegrationProps } from '../types';

export const BitespeedSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
       <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Business ID</label>
        <input
          type="text"
          value={config.businessId || ''}
          onChange={(e) => onChange({ businessId: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">API Access Token</label>
        <input
          type="password"
          value={config.accessToken || ''}
          onChange={(e) => onChange({ accessToken: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};